import { createSelector } from 'reselect'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from 'redux/store'

export enum ModalContent {
    SIGNUP = 'signup',
    ERROR = 'error',
    FULL_RECORDING = 'full-recording',
}

interface GlobalModalState {
    open: boolean
    canClose: boolean
    content: ModalContent | null
}

export const initialState: GlobalModalState = { open: false, canClose: true, content: null }

const globalModalSlice = createSlice({
    name: 'globalModal',
    initialState,
    reducers: {
        resetState: _ => initialState,
        open: (
            state,
            { payload: { canClose, content } }: PayloadAction<{ canClose?: boolean; content: ModalContent }>,
        ) => {
            state.open = true
            state.canClose = canClose !== false //If no canClose is specified (i.e. undefined), canClose is true
            state.content = content
        },
        close: state => {
            state.open = false
            state.canClose = true
            state.content = null
        },
    },
})

const { actions, reducer } = globalModalSlice // Extract the action creators object and the reducer

export const { resetState, open: openModal, close: closeModal } = actions

export default reducer

//Selectors

export const getGlobalModal = (store: RootState) => store.globalModal
export const isModalOpen = createSelector(getGlobalModal, modal => modal.open)
export const canCloseModal = createSelector(getGlobalModal, modal => modal.canClose)
export const getModalContent = createSelector(getGlobalModal, modal => modal.content)
